import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css'; 


function divider() {
  // var item;
  // if (item == null) {
  //   this.item = ['fa-java', 'fa-angular', 'fa-react']
  // }
  // item.forEach(element => {
   
  // });

  return <section className="techDivider">

    <div className="container-fluid bg-light py-3">
      <div className="row">
        <div className="col-md-1 col-4  d-flex justify-content-center    ">
          <i className="fab fa-java fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-angular fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-envira fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-js fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-docker fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fa fa-database fa-3x"></i>\
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-node fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-npm fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-jenkins fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-sass fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fa-css3-alt fa-3x"></i>
        </div>
        <div className="col-md-1 col-4 d-flex justify-content-center  ">
          <i className="fab fab fa-aws fa-3x"></i>
        </div>

      </div>
    </div>
  </section>
}

export default divider 